import { IForm } from '@/components/types'
import { useSearchVideoTitle } from '@/hooks/useSearch'

const [fetchSuggestions] = useSearchVideoTitle()

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'autocomplete',
      label: '视频标题',
      placeholder: '请输入视频标题',
      otherOptions: {
        clearable: true,
        'fetch-suggestions': fetchSuggestions
      }
    },
    {
      field: 'materialDeptType',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'materialType',
      type: 'select',
      label: '素材分类',
      clearable: true,
      placeholder: '请选择素材分类'
    },
    {
      field: 'teacherId',
      type: 'select',
      label: '老师',
      clearable: true,
      placeholder: '请选择老师'
    },
    {
      field: 'courseId',
      type: 'select',
      label: '课程',
      clearable: true,
      placeholder: '请选择课程'
    },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    }
  ]
}
